import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=3bd600ea&scoped=true&"
import script from "./ActivateAccount.vue?vue&type=script&lang=js&"
export * from "./ActivateAccount.vue?vue&type=script&lang=js&"
import style0 from "./ActivateAccount.vue?vue&type=style&index=0&id=3bd600ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd600ea",
  null
  
)

export default component.exports